/* eslint-disable no-underscore-dangle */
import { FunctionComponent } from 'react';

interface ComponentInfo {
  component: FunctionComponent<any>;
  isBlock: boolean;
}

const registry: {
  namedComponents: { [key: string]: ComponentInfo };
  _checkers: CheckFn[];
  _checkerComponents: ComponentInfo[];
} = { _checkers: [], _checkerComponents: [], namedComponents: {} };

type CheckFn = (attributes: object) => boolean;

export function registerComponent(name: string | CheckFn, component: ComponentInfo['component'], isBlock = false) {
  if (typeof name === 'function') {
    registry._checkers.push(name);
    registry._checkerComponents.push({ component, isBlock });
  } else {
    registry.namedComponents[name] = { component, isBlock };
  }
}

export function resolveCustomComponent(
  attributes: {
    [key: string]: string | number;
  },
  hasChildren: boolean
): ComponentInfo | null {
  if (attributes.is && registry.namedComponents[attributes.is]) {
    const compInfo = registry.namedComponents[attributes.is];
    if ((compInfo.isBlock && hasChildren) || (!compInfo.isBlock && !hasChildren)) {
      return compInfo;
    }
  }

  for (let i = 0; i < registry._checkers.length; i += 1) {
    if (registry._checkers[i](attributes)) {
      const compInfo = registry._checkerComponents[i];
      if ((compInfo.isBlock && hasChildren) || (!compInfo.isBlock && !hasChildren)) {
        return compInfo;
      }
    }
  }

  return null;
}

export default registry;
